import { render } from "./propertiesTitle.vue?vue&type=template&id=5f35a3e6"
import script from "./propertiesTitle.vue?vue&type=script&lang=js"
export * from "./propertiesTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__